import { Box } from "@mui/material";
import logo from "../../../assets/logo.png";

export const UILogo = () => {
  return <Box component="img" src={logo} sx={{ marginTop: "1rem" }} />;
};
